import { cx } from '../lib/cx';

/**
 * Skeleton po obliku sadržaja — ARHITEKTURA.md sekcija 10 izričito zabranjuje
 * spinner preko cijelog ekrana.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cx('block animate-pulse rounded-md bg-bg-alt', className)}
    />
  );
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <span className={cx('flex flex-col gap-2', className)}>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} className={cx('h-3', i === lines - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </span>
  );
}

export function SkeletonCard({ className }: { className?: string }) {
  return (
    <div className={cx('rounded-xl border border-line-subtle bg-surface p-5 shadow-card', className)}>
      <Skeleton className="mb-4 h-4 w-1/3" />
      <SkeletonText lines={3} />
    </div>
  );
}

export function SkeletonList({ rows = 4, className }: { rows?: number; className?: string }) {
  return (
    <div className={cx('flex flex-col gap-3', className)} data-testid="skeleton-list">
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className="flex items-center gap-4 rounded-xl border border-line-subtle bg-surface p-4 shadow-card"
        >
          <Skeleton className="h-11 w-11 rounded-full" />
          <span className="flex-1">
            <Skeleton className="mb-2 h-3 w-1/3" />
            <Skeleton className="h-3 w-1/2" />
          </span>
        </div>
      ))}
    </div>
  );
}
